import { useCallback, useEffect, useState } from 'react'
import { mockAdapter } from './mock-adapter'

type AsyncState<T> =
  | { status: 'loading'; data: null; error: null }
  | { status: 'ready'; data: T; error: null }
  | { status: 'error'; data: null; error: Error }

export function useAdapterData<T>(loader: () => Promise<T>) {
  const [state, setState] = useState<AsyncState<T>>({ status: 'loading', data: null, error: null })
  const load = useCallback(() => {
    setState({ status: 'loading', data: null, error: null })
    loader()
      .then((data) => setState({ status: 'ready', data, error: null }))
      .catch((error: unknown) => setState({ status: 'error', data: null, error: error instanceof Error ? error : new Error('Unknown error') }))
  }, [loader])

  useEffect(load, [load])
  return { ...state, retry: load }
}

export const adapterLoaders = {
  home: () => mockAdapter.getHome(),
  training: () => mockAdapter.getTrainingModules(),
  revenue: () => mockAdapter.getRevenue(),
  thanks: () => mockAdapter.getThanksActivity(),
  badges: () => mockAdapter.getBadges(),
  notifications: () => mockAdapter.getNotifications(),
  documents: () => mockAdapter.getDocuments(),
}
